import { Loader } from "@mantine/core";

const BarLoading = () => {
  return (
    <div className="flex items-center h-full justify-center w-full">
      <Loader color="#1E44FF" type="bars" />
    </div>
  );
};

export default BarLoading;
